var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartialWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5682 11.54C15.8796 8.69643 13.2611 4.28357 11.5894 1.46929C11.0485 0.556429 10.0569 0 8.98915 0C7.92134 0 6.92976 0.556429 6.3889 1.46929L0.410831 11.54C-0.130031 12.4514 -0.138093 13.5821 0.393975 14.5007C0.93044 15.43 1.93082 16 3.01108 16H14.9687C16.0489 16 17.0493 15.43 17.5858 14.5007C18.1171 13.5821 18.1098 12.4514 17.5689 11.54H17.5682ZM8.98915 13.3336C8.34128 13.3336 7.81654 12.8221 7.81654 12.1907C7.81654 11.5593 8.34128 11.0479 8.98915 11.0479C9.63701 11.0479 10.1617 11.5593 10.1617 12.1907C10.1617 12.8221 9.63701 13.3336 8.98915 13.3336ZM10.1617 8.76214C10.1617 9.39286 9.63627 9.905 8.98915 9.905C8.34202 9.905 7.81654 9.39286 7.81654 8.76214V4.95286C7.81654 4.32214 8.34202 3.81 8.98915 3.81C9.63627 3.81 10.1617 4.32214 10.1617 4.95286V8.76214Z",
    fill: "#003032"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartialWarning);
export default __webpack_public_path__ + "static/media/partial-warning.db29b89661ef7dbd7cc9091718f0e545.svg";
export { ForwardRef as ReactComponent };